import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=53121a8c&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53121a8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53121a8c')) {
      api.createRecord('53121a8c', component.options)
    } else {
      api.reload('53121a8c', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=53121a8c&scoped=true&", function () {
      api.rerender('53121a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ogyq2c6sYiCu/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports